import { useCallback } from 'react'

import { useWorkflowSchema } from 'data/hooks/workflows/workflows'

export function useConditionalFinalSchema() {
    const { data: schema } = useWorkflowSchema()

    return useCallback(
        (
            config: WorkflowConditionalConfig,
            _contextSchema: WorkflowSchemaStateItem[]
        ): WorkflowSchemaConditionalType | undefined => {
            const type = schema?.nodes.find((t) => t.id === config.kind) as
                | WorkflowSchemaConditionalType
                | undefined

            if (!type) {
                return undefined
            }

            // For conditional nodes, we don't need to modify the schema based on the
            // conditions, as the conditions use the existing context schema.
            // We just return the type as is.
            return {
                ...type,
                state: type.state?.slice() ?? [],
            }
        },
        [schema?.nodes]
    )
}
